import authService from '@/services/auth.service'

export default {
  namespaced: true,
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
    permissions: JSON.parse(localStorage.getItem('permissions')) || [],
    roles: JSON.parse(localStorage.getItem('roles')) || [],
    userType: localStorage.getItem('userType') || null,
    company: JSON.parse(localStorage.getItem('company')) || null,
    department: JSON.parse(localStorage.getItem('department')) || null,
    loading: false,
    error: null
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      if (user) {
        localStorage.setItem('user', JSON.stringify(user))
      } else {
        localStorage.removeItem('user')
      }
    },
    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
      if (permissions) {
        localStorage.setItem('permissions', JSON.stringify(permissions))
      } else {
        localStorage.removeItem('permissions')
      }
    },
    SET_ROLES(state, roles) {
      state.roles = roles
      if (roles) {
        localStorage.setItem('roles', JSON.stringify(roles))
      } else {
        localStorage.removeItem('roles')
      }
    },
    SET_USER_TYPE(state, userType) {
      state.userType = userType
      if (userType) {
        localStorage.setItem('userType', userType)
      } else {
        localStorage.removeItem('userType')
      }
    },
    SET_COMPANY(state, company) {
      state.company = company
      if (company) {
        localStorage.setItem('company', JSON.stringify(company))
      } else {
        localStorage.removeItem('company')
      }
    },
    SET_DEPARTMENT(state, department) {
      state.department = department
      if (department) {
        localStorage.setItem('department', JSON.stringify(department))
      } else {
        localStorage.removeItem('department')
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        
        const response = await authService.login(credentials)
        
        if (response.success) {
          const { user, token } = response.data
          
          commit('SET_USER', user)
          commit('SET_TOKEN', token)
          commit('SET_PERMISSIONS', user.permissions || [])
          commit('SET_ROLES', user.roles || [])
          commit('SET_USER_TYPE', user.user_type || null)
          commit('SET_COMPANY', user.company || null)
          commit('SET_DEPARTMENT', user.department || null)
          
          return { success: true, data: response.data }
        } else {
          throw new Error(response.message || 'فشل تسجيل الدخول')
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'حدث خطأ أثناء تسجيل الدخول'
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async logout({ commit }) {
      try {
        commit('SET_LOADING', true)
        await authService.logout()
      } catch (error) {
        console.error('Logout error:', error)
      } finally {
        commit('SET_USER', null)
        commit('SET_TOKEN', null)
        commit('SET_PERMISSIONS', [])
        commit('SET_ROLES', [])
        commit('SET_USER_TYPE', null)
        commit('SET_COMPANY', null)
        commit('SET_DEPARTMENT', null)
        commit('SET_LOADING', false)
      }
    },
    
    async checkAuth({ commit, state }) {
      if (!state.token) return false
      try {
        commit('SET_LOADING', true)
        const response = await authService.checkAuth()
        
        if (response.success && response.data) {
          commit('SET_USER', response.data.user)
          return true
        }
        
        throw new Error('Invalid authentication')
      } catch (error) {
        commit('SET_USER', null)
        commit('SET_TOKEN', null)
        commit('SET_PERMISSIONS', [])
        commit('SET_ROLES', [])
        commit('SET_USER_TYPE', null)
        commit('SET_COMPANY', null)
        commit('SET_DEPARTMENT', null)
        return false
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    currentUser: state => state.user,
    userFullName: state => {
      if (!state.user) return ''
      const firstName = state.user.first_name_ar || state.user.first_name_en || ''
      const lastName = state.user.last_name_ar || state.user.last_name_en || ''
      return `${firstName} ${lastName}`.trim()
    },
    userRoles: state => state.roles,
    userPermissions: state => state.permissions,
    userType: state => state.userType,
    userCompany: state => state.company,
    userDepartment: state => state.department,
    hasRole: state => role => {
      if (Array.isArray(role)) {
        return role.some(r => state.roles.includes(r))
      }
      return state.roles.includes(role)
    },
    hasPermission: state => permission => {
      if (Array.isArray(permission)) {
        return permission.some(p => state.permissions.includes(p))
      }
      return state.permissions.includes(permission)
    },
    isAdmin: state => state.roles.includes('admin') || state.userType === 'super_admin',
    isHR: state => state.roles.includes('hr') || state.roles.includes('admin') || state.userType === 'super_admin',
    isEmployee: state => state.roles.includes('employee') && !state.roles.includes('admin') && state.userType !== 'super_admin'
  }
} 